import Post from '@/models/Post/Post';

export default class PostFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.title = '';
		this.contentMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			title : '0',
			contentMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}